// imports
import React from 'react';
import { ICON, IMAGE } from '../assets';
import { TEXTS, LINKS } from '../constants';
import { DATE_UTILS } from '../common/utils';
import CookieBanner from '../atoms/cookieBanner';
import { Image, ImageCover } from '../atoms/image';
import ConnectButton from '../atoms/button/connect';
import GameStatePopup from '../molecules/gameState';
import { useConnection } from '../repositories/web3/session';
import { logAnalytics, EventName } from '../services/firebase';

// exports
export default function Home(): JSX.Element {
  // hooks configuration
  const { isConnected } = useConnection();

  // private methods
  const openInNewTab = (url: string, name: EventName, eventParams = {}): void => {
    window.open(url, '_blank', 'noreferrer');
    logAnalytics({ action: 'CLICK', name, eventParams });
  };

  // render
  return (
    <div className="sbg-container">
      <GameStatePopup />
      <div className="backgrounds">
        <ImageCover className="sky-background" src={IMAGE.HOME_SKY_BG} />
        <ImageCover className="dragon-background" src={IMAGE.HOME_DRAGON_BG} />
        <ImageCover className="castle-background" src={IMAGE.HOME_CASTLE_BG} />
        <div className="trees">
          <div className="tree-bottom-left-outer">
            <Image className="tree-bottom-left" src={IMAGE.HOME_TREE_BOTTOM_LEFT} />
          </div>
          <div className="tree-bottom-right-outer">
            <Image className="tree-bottom-right" src={IMAGE.HOME_TREE_BOTTOM_RIGHT} />
          </div>
          <div className="tree-top-left-outer">
            <Image className="tree-top-left" src={IMAGE.HOME_TREE_TOP_LEFT} />
          </div>
          <div className="tree-top-right-outer">
            <Image className="tree-top-right" src={IMAGE.HOME_TREE_TOP_RIGHT} />
          </div>
          <div className="tree-dark-foreground-outer">
            <ImageCover className="tree-dark-foreground" src={IMAGE.HOME_TREE_DARK_FG} />
          </div>
        </div>
      </div>
      <div className="content">
        <div className="top">
          <div className="inner">
            <div className="inner-logo-outer">
              <ImageCover className="logo-sbg" src={IMAGE.HOME_LOGO_GENESIS} />
            </div>
            <div className="connect">
              <ConnectButton navigates />
              <p className="message">
                {TEXTS.PAGE_HOME}
                {' '}
                {!isConnected && (<span>{TEXTS.WALLET_CONNECT}</span>)}
              </p>
            </div>
            <div className="call-to-action">
              <button
                type="button"
                className="discord"
                onClick={() => openInNewTab(LINKS.DISCORD, 'CALL_TO_ACTION', { media: 'discord' })}
              >
                <Image className="icon" height="20" width="27" src={ICON.HOME_DISCORD_SMALL} alt="discord" />
                <span>Join Discord</span>
              </button>
              <button
                type="button"
                className="twitter"
                onClick={() => openInNewTab(LINKS.TWITTER, 'CALL_TO_ACTION', { media: 'twitter' })}
              >
                <Image className="icon" height="20" width="20" src={ICON.HOME_TWITTER_SMALL} alt="twitter" />
                <span>Follow X</span>
              </button>
            </div>
          </div>
        </div>
        <div className="bottom-bar">
          <a target="_blank" href={LINKS.REVOLVING_GAMES} rel="noreferrer" className="logo">
            <Image src={IMAGE.HOME_LOGO_RG} alt="logoRG" width="150" />
          </a>
          <div className="tos-group">
            <div className="copyright">
              ©
              &nbsp;
              {DATE_UTILS.getYear()}
              &nbsp;
              Revolving Games, all rights reserved.
            </div>
            <div className="vline vline1">|</div>
            <div className="tos">
              <a href={LINKS.TOS} target="_blank" rel="noreferrer"> Terms of Use</a>
            </div>
            <div className="vline vline2">|</div>
            <div className="privacy">
              <a href={LINKS.PRIVACY_POLICY} target="_blank" rel="noreferrer"> Privacy Policy</a>
            </div>
          </div>
          <div className="social-links">
            <ul>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.INSTAGRAM, 'SOCIAL_MEDIA_LINK', { media: 'instagram' })}
                >
                  <Image src={ICON.HOME_INSTAGRAM} alt="instagram" />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.FACEBOOK, 'SOCIAL_MEDIA_LINK', { media: 'facebook' })}
                >
                  <Image src={ICON.HOME_FACEBOOK} alt="facebook" />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.DISCORD, 'SOCIAL_MEDIA_LINK', { media: 'discord' })}
                >
                  <Image src={ICON.HOME_DISCORD} alt="discord" />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.TWITTER, 'SOCIAL_MEDIA_LINK', { media: 'twitter' })}
                >
                  <Image src={ICON.HOME_TWITTER} alt="twitter" />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.YOUTUBE, 'SOCIAL_MEDIA_LINK', { media: 'youtube' })}
                >
                  <Image src={ICON.HOME_YOUTUBE} alt="youtube" />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.TWITCH, 'SOCIAL_MEDIA_LINK', { media: 'twitch' })}
                >
                  <Image src={ICON.HOME_TWITCH} alt="twitch" />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.TIK_TOK, 'SOCIAL_MEDIA_LINK', { media: 'tiktok' })}
                >
                  <Image src={ICON.HOME_TIKTOK} alt="tiktok" />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openInNewTab(LINKS.MEDIUM, 'SOCIAL_MEDIA_LINK', { media: 'medium' })}
                >
                  <Image src={ICON.HOME_MEDIUM} alt="medium" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <CookieBanner />
    </div>
  );
}
